// Hamburger menu for small screens: toggles the header links as a list.
// Closes on link click (same-page anchors), Escape, or a click outside.
// Also swaps the header's account links when signed in (lib/session-hint.ts),
// runs the tab sets (the landing's before-and-after proof, the app library) and opens the one in the URL hash,
// and hides the mobile pricing bar while #pricing is on screen.
import { bindNavToggle } from '../lib/nav'
import { bindPricingBar } from '../lib/pricing-bar'
import { bindScrollTop } from '../lib/scroll-top'
import { bindTabs, selectFromHash } from '../lib/tabs'
import { applySessionHint, clearOldHint } from '../lib/session-hint'

clearOldHint()
applySessionHint()

document.querySelectorAll<HTMLButtonElement>('[data-nav-toggle]').forEach(bindNavToggle)
document.querySelectorAll<HTMLAnchorElement>('[data-scroll-top]').forEach((link) => bindScrollTop(link))
document.querySelectorAll<HTMLElement>('[data-pricing-bar]').forEach((bar) => bindPricingBar(bar))
bindTabs()
selectFromHash(window.location.hash)
window.addEventListener('hashchange', () => selectFromHash(window.location.hash))
